<template>
  <div class="page">
    <dashboard-header></dashboard-header>
    
    <div class="content">
      <div class="container-fluid">
        <!-- Page title -->
        <div class="page-header">
          <div class="row align-items-center">
            <div class="col-auto">
              <h2 class="page-title">
                Report a Bug
              </h2>
            </div>
          </div>
        </div>
      
        <div class="row row-deck row-cards">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body" v-show="!isSubmitted">
                <form>
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">Client Zoho Id/Client URL</div>
                        </div>
                        <input type="text" class="form-control" placeholder="https://client.netreputation.com/#/client/&lt;id here&gt;" v-model="txtClientURL" />
                      </div>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">Bug/Issue</div>
                        </div>
                        <textarea :class="`form-control ${issueError ? 'is-invalid' : ''}`" rows="5" v-model="txtIssue"></textarea>
                      </div>
                    </div>
                  </div>
                  
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">Preferred Contact Email</div>
                        </div>
                        <input type="text" :class="`form-control ${emailError ? 'is-invalid' : ''}`" placeholder="yourname@netreputation.com" v-model="txtEmail" />
                      </div>
                    </div>
                  </div>
                  
                  <button class="btn btn-primary" @click.prevent="onSaveBug" v-show="!processing">Submit Bug Report</button>
                  <img src="../assets/ajax-loader.gif" v-show="processing" />
                </form>
              </div>
              
              <div class="card-body" v-show="isSubmitted">
                <h2>Thank you for submitting a bug report. You will be contacted as soon as possible with further updates.</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <dashboard-footer></dashboard-footer>
  </div>
</template>

<script>
  import DashboardHeader from "./DashboardHeader.vue";
  import DashboardFooter from "./DashboardFooter.vue";
  import WebLLCRESTApi from "../api/api";
  import uuid from "../util/uuid";
  
  export default {
    created() {
      // prepare api
      this.api = new WebLLCRESTApi("Bugs", this.$router);
    },
    
    data() {
      return {
        txtClientURL: "",
        txtIssue: "",
        txtEmail: "",
        
        processing: false,
        issueError: false,
        emailError: false,
        isSubmitted: false
      };
    },
    
    methods: {
      async onSaveBug() {
        this.processing = true;
        this.issueError = false;
        this.emailError = false;
        
        if(!this.txtIssue) {
          this.issueError = true;
          this.processing = false;
          return false;
        }
        
        if(!this.txtEmail) {
          this.emailError = true;
          this.processing = false;
          return false;
        }
        
        const newBug = {
          "id": uuid.genUuidV4(),
          "client": this.txtClientURL,
          "details": this.txtIssue,
          "email": this.txtEmail
        };
        
        const res = await this.api.addData(newBug);
        
        if(res.status == 200 || res.status == 204) {
          this.processing = false;
          this.isSubmitted = true;
          return await res.json();
        }
        else {
          alert("Unknown error");
        }
      }
    },
    
    components: {
      DashboardHeader,
      DashboardFooter
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/BugTracker.vue